module.exports = __webpack_public_path__ + "static/media/aluminium_doors.a14a1284.pdf";